import { render, staticRenderFns } from "./AberturaPreMatriculasPage.vue?vue&type=template&id=205c223a&scoped=true"
import script from "./AberturaPreMatriculasPage.vue?vue&type=script&lang=js"
export * from "./AberturaPreMatriculasPage.vue?vue&type=script&lang=js"
import style0 from "./AberturaPreMatriculasPage.vue?vue&type=style&index=0&id=205c223a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205c223a",
  null
  
)

export default component.exports